<template>
    <div class="section pad-sml">
      <div id="learnosity_assess"></div>
    </div>
</template>

<script>
  /* global LearnosityItems:true */
  import { mapActions } from 'vuex'
  
  export default {
    name: 'assessment-launch',
    props: ['entityUuid', 'courseUuid', 'sessionId'],
    data () {
      return {
        itemsApp: {}
      }
    },

    mounted () {
      this.initLaunchAssessment()
    },

    beforeDestroy () {
      if (typeof this.itemsApp.reset === 'function') {
        this.itemsApp.reset()
      }
    },

    methods: {
      ...mapActions([
        'launchAssessment',
        'updateAttempt',
        'showLocalPracticeReview'
      ]),

      initLaunchAssessment () {
        this.launchAssessment({uuid: this.entityUuid, courseId: this.courseUuid, sessionId: this.sessionId}).then(res => {
          if (res) {
            if (res.isCompleted) {
              return this.$router.push({ name: 'entityResult', params: { uuid: this.courseUuid, entityType: 'LearningContent', entityUuid: this.entityUuid } })
            }
            const sessionId = res.sessionId
            const externalId = res.externalId
            const isLocalPractice = res.isLocalPractice
            const signedRequest = JSON.parse(res.signedRequest)
            this.initialize(signedRequest, sessionId, externalId, isLocalPractice)
          }
        })
      },

      initialize (signedRequest, sessionId, externalId, isLocalPractice) {
        var self = this
        self.itemsApp = LearnosityItems.init(signedRequest, {
          'readyListener': function () {
            self.bindReadyListener(sessionId, externalId, isLocalPractice)
          },
          'errorListener': function (event) {
            console.log('error: ', event)
          }
        })
      },

      bindReadyListener (sessionId, externalId, isLocalPractice) {
        this.getMinAndMaxScoreForActiveQuestion()
        let assessApp = this.itemsApp.assessApp()
        assessApp.on('item:load', () => {
          this.getMinAndMaxScoreForActiveQuestion()
        }).on('test:finished:submit', () => {
          if (isLocalPractice) {
            let count = 1
            $.each(this.itemsApp.getItems(), (index, item) => {
              let element = '<span class="learnosity-item" data-reference="' + index + '">'
              let title = '<span class="question_title" style="display: none; font-size: larger; font-family: robotoSlab_Light;">Question ' + count + '</span>'
              let review = title + element
              $(review).appendTo('#local_practice_review')
              count++
            })
            let responses = this.itemsApp.getResponses()
            this.showReview(sessionId, responses)
          } else {
            this.saveAndExit(true, sessionId, externalId)
          }
        }).on('test:submit:error', function () {
          console.log('test submit error')
        })
      },

      getMinAndMaxScoreForActiveQuestion () {
        $.each(this.itemsApp.getItems(), (index, item) => {
          if (item.active) {
            let maxScore = 0
            $.each(item.questions, (i, question) => {
              if (question.metadata.valid_response_count === 0) {
                maxScore += (question.validation && question.validation.max_score) ? question.validation.max_score : 0
              }
            })
            $('.lrn-min-max-score').remove()
            if (maxScore > 0) {
              $('.lrn-top-left-region').append('<div class="lrn-min-max-score">Min Score: 0 and Max Score: ' + maxScore + '</div>')
            }
          }
        })
      },

      showReview (sessionId, responses) {
        this.showLocalPracticeReview({uuid: this.entityUuid, courseId: this.courseUuid, sessionId: sessionId, responses: responses}).then(res => {
          if (res) {
            if (typeof this.itemsApp.reset === 'function') {
              this.itemsApp.reset()
              $('#learnosity_assess').hide()
            }
            let self = this
            const signedRequest = JSON.parse(res.signedRequest)
            self.itemsApp = LearnosityItems.init(signedRequest, {
              'readyListener': function () {
                $('.question_title').css('display', 'block')
                self.$emit('localPracticeReviewLoaded', true)
              },
              'errorListener': function (event) {
                console.log('error: ', event)
              }
            })
          }
        })
      },

      saveAndExit (isFinished, sessionId, externalId, isLocalPractice) {
        if (isFinished) {
          this.updateAttempt({sessionId: sessionId, externalId: externalId, isFinished: isFinished}).then(res => {
            if (res && res.isSubmitted) {
              return this.$router.push({ name: 'entityResult', params: { uuid: this.courseUuid, entityType: 'LearningContent', entityUuid: this.entityUuid } })
            } else {
              this.$notify({
                group: 'notify',
                type: 'warn',
                duration: 5000,
                title: 'Network Error',
                text: 'Failed to connect with item bank. Please click on "Resume Knowledge Check" and re-submit.'
              })
              return this.$router.push({ name: 'entityDetail', params: { uuid: this.courseUuid, entityType: 'LearningContent', entityUuid: this.entityUuid } })
            }
          })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentLaunch.vue